export default __webpack_public_path__ + "static/media/CM_detector.892000d5.svg";